import { createSlice } from "@reduxjs/toolkit";

export const createAccountGs1Slice = createSlice({
  name: "createAccount",
  initialState: {
    data: null,
    error: null,
    isLoading: false
  },
  reducers: {
    startCreateAccountGs1: (state) => { state.isLoading = true },
    setCreateAccountGs1: (state, { payload: { data = null, error = null }}) => {
      state.data = data;
      state.error = error;
      state.isLoading = false;
    }
  }
});

export const { startCreateAccountGs1, setCreateAccountGs1 } = createAccountGs1Slice.actions;
